import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

export const addSeparatorToData: [] = (dataArray: [], filedNamesArray: []) => {

   const data = [...dataArray]
  data.forEach((row, indexRow) => {

    const keys = Object.keys(row);
    keys.forEach(key => {

      if (filedNamesArray.includes(key)) {
        row[key] = formatToPersianAddComma(row[key])
      }
    })
  })
  return data


}